// src/pages/Services.jsx
import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Services.css';

import consultationImg from '../assets/images/servicesConsult.jpg';
import customisedImg from '../assets/images/servicesmedicine.jpg';
import garbhasamskaraImg from '../assets/images/servicesgarbha.jpg';
import swarnaprashanaImg from '../assets/images/ServicesSwarna.jpg';
import panchakarmaImg from '../assets/images/servicespancha.jpg';

import { supabase } from "../lib/supabaseClient";

const services = [
  {
    title: "Ayurvedic Consultation",
    image: consultationImg,
    description:
      "Sudhamshu Ayurveda offers holistic Ayurvedic consultations, blending personalized medicines with lifestyle guidance for complete wellness.Special expertise includes headache, migraine, asthma, gastritis, IBS, constipation, and skin disorders.We also address menstrual issues like DUB, dysmenorrhoea, infertility, and PCOD, along with diabetes, hypertension, and thyroid problems.Treatment extends to arthritis, osteoarthritis, and various joint-related disorders."
  },
  {
    title: "Customised Medication",
    image: customisedImg,
    description:
      "Ayurveda believes in individualized treatment and customized/ tailor made therapy – medications for each person. Our doctor abides by this principle and ensures every person/ patient in thoroughly analyzed and treated accordingly"
  },
  {
    title: "Garbhasamskara",
    image: garbhasamskaraImg,
    description:
      "The word Garbha samskara comprises of 2 words: Garbha- Fetus & Samskara-Transformation/Refinement; thus meaning the Physical, Psychological and Emotional well being and refinement of fetal health.Garbha samskara is a journey from prior to conception (preconception) to the delivery of a healthy progeny along with care of newborn and mother.HOMBALE TREATMENT for Pregnant women is our specialized approach."
  },
  {
    title: "Swarnaprashana",
    image: swarnaprashanaImg,
    description:
      "Ensure your child's healthy growth by boosting their immunity and promoting overall development of child through Swarnaprashana! It enhances Cognitive ability, speech, memory and metabolism. The practice dates back to thousands of years ago wherein its benefits are of great value. Swarnaprashana is specifically designed for kids of age 0-16years."
  },
  {
    title: "Panchakarma",
    image: panchakarmaImg,
    description:
      "Panchakarma is a traditional Ayurvedic therapy that detoxifies and rejuvenates the body, mind, and spirit, effectively balancing the doshas (Vata, Pitta, and Kapha) for better health. It removes accumulated toxins (Ama) through treatments like Vamana (therapeutic vomiting), Virechana (purgation), Basti (medicated enema), Nasya (nasal medication), and Raktamokshana (bloodletting). At Sudhamshu Ayurveda, we also offer specialized external therapies such as Janu Basti, Kati Basti, Greeva Basti, and Patra Pinda Sweda. These unique procedures help relieve pain, improve mobility, and restore overall well-being."
  }
];

// const Services = () => {
//   return (
//     <>
//       <Navbar />
//       <section className="services-layout">
//         <div className="services-header">
//           <h2>Our Services</h2>
//           <p className="subheading">Holistic healing with ancient Ayurvedic wisdom</p>
//         </div>
//         <div className='services-content'>
//           <div className="services-list">


//             {services.map((service, index) => (
//               <React.Fragment key={index}>
//                 <div className={`service-block ${index % 2 === 0 ? 'left' : 'right'}`}>
//                   <div className="service-img">
//                     <img src={service.image} alt={service.title} />
//                   </div>
//                   <div className="service-info">
//                     <h3>{service.title}</h3>
//                     <p>{service.description}</p>
//                   </div>
//                 </div>

//                 {/* Insert Schedule after Swarnaprashana (index 3) */}
//                 {service.title === "Swarnaprashana" && (
//                   <div className="swarnaprashana-schedule">
//                     <h3>Swarnaprashana Schedule 2025</h3>
//                     <h4>As per schedule on Pushya Nakshatra every month.</h4>
//                     <ul>
//                       {swarnaprashanaSchedule2025.map((item, index) => (
//                         <li key={index}>
//                           {item.date} – {item.day}
//                         </li>
//                       ))}
//                     </ul>
//                     <button
//                       className="book-slot-btn"
//                       onClick={() => (window.location.href = "/contact")}
//                     >
//                       Book Your Slot Now
//                     </button>
//                   </div>
//                 )}
//               </React.Fragment>
//             ))}

//           </div>
//         </div>


//       </section>
//       <Footer />
//     </>
//   );
// };


const Services = () => {
  const [schedule, setSchedule] = useState([]);
  const [loadingSchedule, setLoadingSchedule] = useState(true);

  useEffect(() => {
    const loadSchedule = async () => {
      const { data, error } = await supabase
        .from("swarnaprashana_schedule")
        .select("id, date")
        .order("date", { ascending: true });

      if (error) {
        console.error(
          "Error loading Swarnaprashana schedule:",
          error
        );
        setLoadingSchedule(false);
        return;
      }

      setSchedule(data || []);
      setLoadingSchedule(false);
    };

    loadSchedule();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");

    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    );

    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const getWeekday = (dateString) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");

    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    );

    return date.toLocaleDateString("en-IN", {
      weekday: "long",
    });
  };

  return (
    <>
      <Navbar />

      <section className="services-layout">

        <div className="services-header">
          <h2>Our Services</h2>
          <p className="subheading">
            Holistic healing with ancient Ayurvedic wisdom
          </p>
        </div>

        <div className="services-content">

          <div className="services-list">

            {services.map((service, index) => (
              <React.Fragment key={index}>

                <div
                  className={`service-block ${
                    index % 2 === 0 ? "left" : "right"
                  }`}
                >
                  <div className="service-img">
                    <img
                      src={service.image}
                      alt={service.title}
                    />
                  </div>

                  <div className="service-info">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                </div>

                {/* Swarnaprashana Schedule */}
                {service.title === "Swarnaprashana" && (
                  <div className="swarnaprashana-schedule">

                    <h3>Swarnaprashana Schedule</h3>

                    <h4>
                      As per schedule on Pushya Nakshatra every month.
                    </h4>

                    {loadingSchedule ? (
                      <p className="schedule-message">Loading schedule...</p>
                    ) : schedule.length === 0 ? (
                      <p className="schedule-message">
                        No Swarnaprashana dates are currently
                        scheduled.
                      </p>
                    ) : (
                      <ul>
                        {schedule.map((item) => (
                          <li key={item.id}>
                            {formatDate(item.date)} –{" "}
                            {getWeekday(item.date)}
                          </li>
                        ))}
                      </ul>
                    )}

                    <button
                      className="book-slot-btn"
                      onClick={() =>
                        (window.location.href = "/contact")
                      }
                    >
                      Book Your Slot Now
                    </button>

                  </div>
                )}

              </React.Fragment>
            ))}

          </div>
        </div>

      </section>

      <Footer />
    </>
  );
};

export default Services;

